import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { IHttpClient } from '@app/domain/ports';

/**
 * Angular HTTP client adapter
 * Adapts Angular's HttpClient to our framework-agnostic IHttpClient port
 */
export class AngularHttpClientAdapter implements IHttpClient {
  /**
   * @param httpClient Angular's HttpClient (injected via DI)
   */
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Performs a GET request using Angular's HttpClient
   * Converts Observable to Promise for framework-agnostic API
   */
  async get<T>(url: string): Promise<T> {
    return firstValueFrom(this.httpClient.get<T>(url));
  }
}
